export default __webpack_public_path__ + "static/media/Repose-Nate-Baldwin.78723a55.jpg";